module.exports = __webpack_public_path__ + "static/media/collaborate-Wed_27.fd6f76c8.jpg";